export interface IoniconHtml {
  __html: string;
}

export class Ionicon {
  /* eslint-disable @typescript-eslint/lines-between-class-members */
  static DONE = new Ionicon('&#xf383;');
  static COPY = new Ionicon('&#xf41b;');
  /* eslint-enable @typescript-eslint/lines-between-class-members */

  private constructor(private readonly htmlCode: string) {}

  toString() {
    return this.htmlCode;
  }

  toHtml(): IoniconHtml {
    return { __html: this.htmlCode };
  }
}
